export const OFFER_COL = {
    match: 84,
    price: 118,
    qty: 84,
    cost: 124,
    logistics: 110,
    total: 126,
    actions: 72,
} as const;